<template>
  <v-card class="header">
    <InternalUserDesktopNav
      v-if="$vuetify.breakpoint.width > 960"
      :showMyUsers="showMyUsers"
      :navTabsOptional="navTabsOptional"
    />
    <InternalUserMobileNav
      v-else
      :showMyUsers="showMyUsers"
      :navTabsOptional="navTabsOptional"
    />
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InternalUserDesktopNav from './InternalUserDesktopNav.vue'
import InternalUserMobileNav from './InternalUserMobileNav.vue'

export default defineComponent({
  name: 'InternalUserNav',
  components: {
    InternalUserDesktopNav,
    InternalUserMobileNav,
  },
  props: {
    showMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
})
</script>
